import {documentToReactComponents} from '@contentful/rich-text-react-renderer'
import {BLOCKS, MARKS} from '@contentful/rich-text-types'

import {Grid, RiverBreakout, Text, Timeline} from '@primer/react-brand'

import type {RichText} from '@github-ui/swp-core/schemas/contentful/richText'

import type {GenericContent} from '../../../../brand/lib/types/contentful'

function renderRichText(richText: RichText) {
  return documentToReactComponents(richText, {
    renderMark: {
      [MARKS.BOLD]: text => <em>{text}</em>,
    },
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_, children) => [children],
    },
  })
}

type Props = {
  riverBreakout: GenericContent
}

export function FeaturesRiverBreakout(props: Props) {
  const {riverBreakout} = props
  const {text, media, content} = riverBreakout.fields
  const imageAsset = media?.[0]

  return (
    <Grid.Column span={12}>
      {/* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */}
      <RiverBreakout className="lp-RiverBreakout">
        {/* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */}
        <RiverBreakout.Visual className="lp-River-visual">
          {imageAsset ? (
            <img
              src={imageAsset.fields.asset.fields.file.url}
              alt={imageAsset.fields.description || imageAsset.fields.asset.fields.description || ''}
            />
          ) : (
            <></>
          )}
        </RiverBreakout.Visual>

        <RiverBreakout.Content
          trailingComponent={
            content
              ? () => (
                  /* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */
                  <Timeline className="lp-Timeline">
                    {content.map(item => (
                      <Timeline.Item key={item.sys.id}>{renderRichText(item.fields.text)}</Timeline.Item>
                    ))}
                  </Timeline>
                )
              : undefined
          }
        >
          {text ? <Text style={{maxWidth: 690}}>{renderRichText(text)}</Text> : <></>}
        </RiverBreakout.Content>
      </RiverBreakout>
    </Grid.Column>
  )
}
